export const setOrderGrooveFrequency = (omsId: string, subscriptionDefaultFrequency: string) => {
    try {
      if (window.OG && window.OG.API) {
        window.OG.API(
          'pdp_nocontent',
          omsId,
          'setFrequency',
          subscriptionDefaultFrequency
        );
      }
    }
    catch (e) {
      console.log("error in setFrequency", e)
    }
}

export const setUpdateCartForOrderGroove = (atcRequest: Object) => {
  try {
    if (window.OG && window.OG.updateCart) {
      window.OG.updateCart([
        {
          id: atcRequest.itemId,
          module: "pdp_nocontent",
          quantity: atcRequest.quantity
        }
      ])
    }
  }
  catch (e) {
    console.log("error in setUpdateCartForOrderGroove ", e);
  }
};